import React, { useContext } from 'react';

const initialState = {
  isMobile: false
};
const DeviceContext = React.createContext(initialState);
const DeviceProvider = ({
  value,
  children
}) => {
  return /* @__PURE__ */ React.createElement(DeviceContext.Provider, {
    value
  }, children);
};
function useDevice() {
  const context = useContext(DeviceContext);
  if (!context) {
    throw new Error("useDevice must be inside a DeviceProvider with a state value");
  }
  return context;
}

export { DeviceProvider, useDevice };
